import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, vModelDynamic as _vModelDynamic, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row gx-1" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "row row gx-2" }
const _hoisted_6 = { class: "col-md-2" }
const _hoisted_7 = { class: "upload-container" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "text-center"
}
const _hoisted_10 = { class: "col-md-10" }
const _hoisted_11 = { class: "row gx-1" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = { class: "form-group mb-3 mb-sm-3 mb-md-3" }
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = { class: "form-group mb-3 mb-sm-3 mb-md-3" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group mb-3 mb-sm-3 mb-md-3" }
const _hoisted_18 = { class: "col-md-4" }
const _hoisted_19 = {
  class: "form-group mb-sm-2 mb-md-2",
  ref: "dropdownRef"
}
const _hoisted_20 = {
  key: 0,
  class: "dropdown-menu show"
}
const _hoisted_21 = {
  class: "dropdown-item",
  href: "javascript:void(0);"
}
const _hoisted_22 = { class: "col-md-4" }
const _hoisted_23 = { class: "form-group mb-3 mb-sm-3 mb-md-3" }
const _hoisted_24 = { class: "col-md-4" }
const _hoisted_25 = { class: "form-group mb-3 mb-sm-3 mb-md-3" }
const _hoisted_26 = { class: "col-md-4" }
const _hoisted_27 = { class: "form-group mb-3 mb-sm-3 mb-md-3" }
const _hoisted_28 = { class: "input-group" }
const _hoisted_29 = { class: "input-group-text" }
const _hoisted_30 = { class: "col-md-12" }
const _hoisted_31 = { class: "form-group mb-3 mb-sm-3 mb-md-3" }
const _hoisted_32 = ["onUpdate:modelValue"]
const _hoisted_33 = { class: "form-group mb-3 mb-sm-3 mb-md-3" }
const _hoisted_34 = { class: "d-block text-black fw-semibold mb-1" }
const _hoisted_35 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_36 = { key: 0 }
const _hoisted_37 = ["onUpdate:modelValue"]
const _hoisted_38 = ["onUpdate:modelValue"]
const _hoisted_39 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_40 = {
  key: 1,
  class: "input-group"
}
const _hoisted_41 = ["onUpdate:modelValue", "name"]
const _hoisted_42 = ["value"]
const _hoisted_43 = ["onUpdate:modelValue", "name"]
const _hoisted_44 = ["value"]
const _hoisted_45 = {
  key: 2,
  class: "input-group"
}
const _hoisted_46 = ["onUpdate:modelValue", "name", "type"]
const _hoisted_47 = {
  key: 3,
  class: "text-danger"
}
const _hoisted_48 = { class: "col-md-12 mb-md-25" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "border border-primary mb-1" }
const _hoisted_51 = {
  class: "row d-flex align-items-center justify-content-between fw-bold py-2",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_52 = { class: "col-md-5" }
const _hoisted_53 = { class: "d-flex float-end" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { class: "col-md-2 mb-3" }
const _hoisted_56 = { class: "" }
const _hoisted_57 = ["value"]
const _hoisted_58 = {
  key: 2,
  class: "invalid-feedback"
}
const _hoisted_59 = { class: "col-md-2 mb-3" }
const _hoisted_60 = { class: "form-group mb-2" }
const _hoisted_61 = ["onUpdate:modelValue"]
const _hoisted_62 = {
  key: 1,
  class: "input-group"
}
const _hoisted_63 = ["onUpdate:modelValue"]
const _hoisted_64 = {
  class: "input-group-text",
  id: "inputGroup-sizing-default"
}
const _hoisted_65 = {
  key: 2,
  class: "invalid-feedback"
}
const _hoisted_66 = { class: "col-md-2 mb-3" }
const _hoisted_67 = { class: "form-group mb-2" }
const _hoisted_68 = ["onUpdate:modelValue"]
const _hoisted_69 = {
  key: 1,
  class: "input-group"
}
const _hoisted_70 = ["onUpdate:modelValue"]
const _hoisted_71 = {
  key: 2,
  class: "invalid-feedback"
}
const _hoisted_72 = {
  key: 3,
  class: "invalid-feedback"
}
const _hoisted_73 = { class: "col-md-2 mb-3" }
const _hoisted_74 = { class: "form-group mb-2" }
const _hoisted_75 = ["onUpdate:modelValue"]
const _hoisted_76 = {
  key: 1,
  class: "input-group"
}
const _hoisted_77 = ["onUpdate:modelValue"]
const _hoisted_78 = {
  key: 2,
  class: "invalid-feedback"
}
const _hoisted_79 = { class: "col-md-2 mb-3" }
const _hoisted_80 = { class: "form-group mb-2" }
const _hoisted_81 = ["onUpdate:modelValue"]
const _hoisted_82 = {
  key: 1,
  class: "input-group"
}
const _hoisted_83 = ["onUpdate:modelValue"]
const _hoisted_84 = {
  key: 2,
  class: "invalid-feedback"
}
const _hoisted_85 = {
  key: 3,
  class: "invalid-feedback"
}
const _hoisted_86 = {
  key: 0,
  class: "col-md-2 mb-3"
}
const _hoisted_87 = ["onClick"]
const _hoisted_88 = { class: "col-md-12" }
const _hoisted_89 = { class: "d-flex align-items-center" }
const _hoisted_90 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h3", { class: "text-black fw-semibold" }, "Ajouter un produit")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "produitForm",
        onSubmit: _ctx.addProduit,
        "keep-values": _ctx.valuess,
        "validation-schema": _ctx.produitSchema,
        "initial-values": { seuilAppro: 0 }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Image Produit ", -1)),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("input", {
                      type: "file",
                      ref: "fileInput",
                      onChange: _cache[0] || (_cache[0] = (event) => _ctx.onFilePrinChange(event)),
                      accept: "image/jpeg, image/png, image/jpg",
                      hidden: ""
                    }, null, 544),
                    _createElementVNode("div", {
                      class: "preview-card",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)))
                    }, [
                      (_ctx.imagePreview)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.imagePreview,
                            alt: "Image preview"
                          }, null, 8, _hoisted_8))
                        : (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[8] || (_cache[8] = [
                            _createElementVNode("div", null, [
                              _createElementVNode("i", { class: "icofont icofont-camera fs-1" })
                            ], -1),
                            _createTextVNode(" Cliquez pour ajouter l'image principal du produit ")
                          ]))),
                      (_ctx.imagePreview)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "button",
                            class: "delete-btn",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeImage && _ctx.removeImage(...args)), ["stop"]))
                          }, _cache[9] || (_cache[9] = [
                            _createElementVNode("i", { class: "icofont icofont-close" }, null, -1)
                          ])))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Code du produit ", -1)),
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "code",
                          class: "form-control shadow-none fs-md-15 text-black",
                          readonly: "true",
                          placeholder: "Ce code est généré"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "code",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Référence usine du produit ", -1)),
                        _createVNode(_component_Field, {
                          name: "refProd",
                          type: "text",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer la référence"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "refProd",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                          _createTextVNode(" Famille du produit"),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, { name: "famille" }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps({
                              options: _ctx.familleOptions,
                              searchable: true,
                              "track-by": "label",
                              label: "label",
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, {
                              onSelect: ($event: any) => (_ctx.selectFamille(field.value)),
                              placeholder: "Sélectionner la famille"
                            }), null, 16, ["options", "modelValue", "onUpdate:modelValue", "onSelect"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "famille",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                          _createTextVNode(" Nom du Produit"),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "nomProd",
                          type: "text",
                          modelValue: _ctx.prodName,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.prodName) = $event)),
                          onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showBox = true)),
                          class: "mb-2 form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer le nom du produit"
                        }, null, 8, ["modelValue"]),
                        (_ctx.produitOptions.length > 0 && _ctx.showBox == true)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_20, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produitOptions, (produit, index) => {
                                return (_openBlock(), _createElementBlock("li", { key: index }, [
                                  _createElementVNode("a", _hoisted_21, _toDisplayString(produit.codeProduit) + " - " + _toDisplayString(produit.nomProd), 1)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ErrorMessage, {
                          name: "nomProd",
                          class: "text-danger"
                        })
                      ], 512)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Unité de Stockage ", -1)),
                        _createVNode(_component_Field, {
                          name: "uniteStock",
                          modelValue: _ctx.uniteStock,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.uniteStock) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps({
                              options: _ctx.conditionnementOptions,
                              searchable: true,
                              "track-by": "label",
                              label: "label",
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, { placeholder: "Choisir l'unité de stockage" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "uniteStock",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Unité de gestion ", -1)),
                        _createVNode(_component_Field, {
                          name: "uniteGestion",
                          modelValue: _ctx.uniteGestion,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.uniteGestion) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps({
                              options: _ctx.conditionnementgOptions,
                              searchable: true,
                              "track-by": "label",
                              label: "label",
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, {
                              onSelect: ($event: any) => (_ctx.seletUniteGestion(field.value)),
                              placeholder: "Choisir l'unité de gestion"
                            }), null, 16, ["options", "modelValue", "onUpdate:modelValue", "onSelect"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "uniteGestion",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Seuil d'approvisionnement ", -1)),
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_Field, {
                            name: "seuilAppro",
                            type: "number",
                            min: "0",
                            class: "form-control shadow-none fs-md-15 text-black",
                            placeholder: "Ex : 10"
                          }),
                          _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.uniteGestion != null ? _ctx.uniteGestion.split("|")[2] : ''), 1)
                        ]),
                        _createVNode(_component_ErrorMessage, {
                          name: "seuilAppro",
                          class: "text-danger"
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Description du produit ", -1)),
                _createVNode(_component_Field, {
                  name: "descProd",
                  as: "textarea",
                  placeholder: "Entrer la description",
                  class: "form-control shadow-none rounded-0 text-black"
                }, {
                  default: _withCtx(({ field }) => [
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control shadow-none rounded-0 text-black",
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, null, 8, _hoisted_32), [
                      [_vModelText, field.value]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "descProd",
                  class: "text-danger"
                })
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chamsdescritifs, (champsLibre, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-md-3",
                key: index
              }, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("label", _hoisted_34, [
                    _createTextVNode(_toDisplayString(champsLibre.libelleChamp) + " ", 1),
                    (champsLibre.estObligatoire == 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  (champsLibre.typeChamp == 'boolean')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createElementVNode("label", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            "onUpdate:modelValue": ($event: any) => ((champsLibre.valeur) = $event),
                            class: _normalizeClass((_ctx.valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1) ? 'form-check shadow-none fs-md-15 text-black is-invalid ' : 'form-control shadow-none fs-md-15 text-black '),
                            name: "status",
                            value: "1",
                            checked: ""
                          }, null, 10, _hoisted_37), [
                            [_vModelRadio, champsLibre.valeur]
                          ]),
                          _cache[19] || (_cache[19] = _createTextVNode(" Oui "))
                        ]),
                        _createElementVNode("label", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            "onUpdate:modelValue": ($event: any) => ((champsLibre.valeur) = $event),
                            class: _normalizeClass((_ctx.valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1) ? 'form-check shadow-none fs-md-15 text-black is-invalid ' : 'form-control shadow-none fs-md-15 text-black '),
                            name: "status",
                            value: "0"
                          }, null, 10, _hoisted_38), [
                            [_vModelRadio, champsLibre.valeur]
                          ]),
                          _cache[20] || (_cache[20] = _createTextVNode(" Non "))
                        ]),
                        (_ctx.valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(champsLibre.libelleChamp) + " est obligatoire. ", 1))
                          : _createCommentVNode("", true)
                      ]))
                    : (champsLibre.typeChamp == 'name')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                          (champsLibre.modeSaisie == 'keywordValueList')
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 0,
                                class: _normalizeClass((_ctx.valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1) ? 'form-select shadow-none fs-md-15 text-black is-invalid ' : 'form-select shadow-none fs-md-15 text-black '),
                                "onUpdate:modelValue": ($event: any) => ((champsLibre.valeur) = $event),
                                name: champsLibre.nomChamp
                              }, [
                                _cache[21] || (_cache[21] = _createElementVNode("option", {
                                  value: "",
                                  disabled: ""
                                }, "Sélectionner", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(champsLibre.valeurPossible, (option, index) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: index,
                                    value: option.value
                                  }, _toDisplayString(option.libelle), 9, _hoisted_42))
                                }), 128))
                              ], 10, _hoisted_41)), [
                                [_vModelSelect, champsLibre.valeur]
                              ])
                            : _createCommentVNode("", true),
                          (champsLibre.modeSaisie == 'keywordKeyValueList')
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 1,
                                class: _normalizeClass((_ctx.valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1) ? 'form-select shadow-none fs-md-15 text-black is-invalid ' : 'form-select shadow-none fs-md-15 text-black '),
                                "onUpdate:modelValue": ($event: any) => ((champsLibre.valeur) = $event),
                                name: champsLibre.nomChamp
                              }, [
                                _cache[22] || (_cache[22] = _createElementVNode("option", {
                                  value: "",
                                  disabled: ""
                                }, "Sélectionner", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(champsLibre.valeurPossible, (option, index) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: index,
                                    value: option.valeur
                                  }, _toDisplayString(option.libelle), 9, _hoisted_44))
                                }), 128))
                              ], 10, _hoisted_43)), [
                                [_vModelSelect, champsLibre.valeur]
                              ])
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _withDirectives(_createElementVNode("input", {
                            class: _normalizeClass((_ctx.valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1) ? 'form-control shadow-none fs-md-15 text-black is-invalid ' : 'form-control shadow-none fs-md-15 text-black '),
                            "onUpdate:modelValue": ($event: any) => ((champsLibre.valeur) = $event),
                            name: champsLibre.nomChamp,
                            type: champsLibre.typeChamp
                          }, null, 10, _hoisted_46), [
                            [_vModelDynamic, champsLibre.valeur]
                          ])
                        ])),
                  (_ctx.valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(champsLibre.libelleChamp) + " est obligatoire. ", 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "col-md-7" }, [
                      _createElementVNode("h3", { class: "fs-4 text-white" }, " Conditionnement(s) du produit ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success", { 'cursor-not-allowed': _ctx.isDisable }]),
                          type: "button",
                          disabled: _ctx.isDisable,
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addRowConditionnement()))
                        }, _cache[23] || (_cache[23] = [
                          _createElementVNode("i", { class: "fa fa-plus-circle position-relative ms-5 fs-12" }, null, -1),
                          _createTextVNode(" Ajouter un conditionnement ")
                        ]), 10, _hoisted_54),
                        _createVNode(_component_router_link, { to: "/liste-mouvements" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "row gx-1" }, [
                      _createElementVNode("div", { class: "col-md-2" }, [
                        _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                          _createTextVNode(" Conditionnement "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-md-2" }, [
                        _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                          _createTextVNode(" Quantité "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-md-2" }, [
                        _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                          _createTextVNode(" Prix Min "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-md-2" }, [
                        _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                          _createTextVNode(" PrixDeVente "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-md-2" }, [
                        _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                          _createTextVNode(" Prix Max "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-md-2" }, [
                        _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Action ")
                      ])
                    ], -1)),
                    _cache[27] || (_cache[27] = _createElementVNode("hr", { class: "mt-0" }, null, -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conditionnements, (conditionnement, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "row gx-1",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("div", _hoisted_56, [
                            (index == 0)
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  type: "text",
                                  readonly: "",
                                  value: _ctx.uniteGestion?.split('|')[2],
                                  class: "form-control shadow-none fs-md-15 text-black"
                                }, null, 8, _hoisted_57))
                              : (_openBlock(), _createBlock(_component_Multiselect, {
                                  key: 1,
                                  options: _ctx.conditionnementOptions,
                                  searchable: true,
                                  "track-by": "label",
                                  label: "label",
                                  modelValue: conditionnement.conditionnement,
                                  "onUpdate:modelValue": ($event: any) => ((conditionnement.conditionnement) = $event),
                                  placeholder: "Sélectionner",
                                  onSelect: ($event: any) => (_ctx.selectConditionnement(conditionnement.conditionnement, conditionnement))
                                }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "onSelect"])),
                            (_ctx.valideteRowProduit(conditionnement.conditionnement))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_58, " Le conditionnement est obligatoire. "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            (index == 0)
                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  type: "text",
                                  readonly: "",
                                  "onUpdate:modelValue": ($event: any) => ((conditionnement.quantite) = $event),
                                  class: "form-control shadow-none fs-md-15 text-black"
                                }, null, 8, _hoisted_61)), [
                                  [_vModelText, conditionnement.quantite]
                                ])
                              : (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    "onUpdate:modelValue": ($event: any) => ((conditionnement.quantite) = $event),
                                    class: _normalizeClass(_ctx.valideteRowProduit(conditionnement.quantite)
                            ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                            : 'form-control shadow-none fs-md-15 text-black '),
                                    placeholder: "Entrer la quantité",
                                    "aria-label": "Sizing example input",
                                    "aria-describedby": "inputGroup-sizing-sm"
                                  }, null, 10, _hoisted_63), [
                                    [_vModelText, conditionnement.quantite]
                                  ]),
                                  _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.uniteGestion != null
                            ? (_ctx.uniteGestion?.split("|")[2]) : 'UM'), 1)
                                ])),
                            (_ctx.valideteRowProduit(conditionnement.quantite))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_65, " La quantité est obligatoire. "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, [
                            (index == 0)
                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  type: "text",
                                  "onUpdate:modelValue": ($event: any) => ((conditionnement.prixMin) = $event),
                                  class: "form-control shadow-none fs-md-15 text-black"
                                }, null, 8, _hoisted_68)), [
                                  [_vModelText, conditionnement.prixMin]
                                ])
                              : (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    "onUpdate:modelValue": ($event: any) => ((conditionnement.prixMin) = $event),
                                    class: _normalizeClass(_ctx.isPrixMinInvalid(conditionnement)
                              ? 'form-control shadow-none fs-md-15 text-black is-invalid'
                              : 'form-control shadow-none fs-md-15 text-black'),
                                    placeholder: "Entrer le prix minimal",
                                    "aria-label": "Saisir le prix minimal",
                                    "aria-describedby": "inputGroup-sizing-sm"
                                  }, null, 10, _hoisted_70), [
                                    [_vModelText, conditionnement.prixMin]
                                  ])
                                ])),
                            (_ctx.isPrixMinInvalid(conditionnement))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_71, " Le prix minimal doit être inférieur ou égal au prix de vente. "))
                              : _createCommentVNode("", true),
                            (_ctx.valideteRowProduit(conditionnement.prixMin))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_72, " Le prix minimal est obligatoire. "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_73, [
                          _createElementVNode("div", _hoisted_74, [
                            (index == 0)
                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  type: "text",
                                  "onUpdate:modelValue": ($event: any) => ((conditionnement.prixVente) = $event),
                                  class: "form-control shadow-none fs-md-15 text-black"
                                }, null, 8, _hoisted_75)), [
                                  [_vModelText, conditionnement.prixVente]
                                ])
                              : (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    "onUpdate:modelValue": ($event: any) => ((conditionnement.prixVente) = $event),
                                    class: _normalizeClass(_ctx.valideteRowProduit(conditionnement.prixVente)
                            ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                            : 'form-control shadow-none fs-md-15 text-black '),
                                    placeholder: "Entrer le prix de vente",
                                    "aria-label": "Sizing example input",
                                    "aria-describedby": "inputGroup-sizing-sm"
                                  }, null, 10, _hoisted_77), [
                                    [_vModelText, conditionnement.prixVente]
                                  ])
                                ])),
                            (_ctx.valideteRowProduit(conditionnement.prixVente))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_78, " Le prix de vente est obligatoire. "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_79, [
                          _createElementVNode("div", _hoisted_80, [
                            (index == 0)
                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  type: "text",
                                  "onUpdate:modelValue": ($event: any) => ((conditionnement.prixMax) = $event),
                                  class: "form-control shadow-none fs-md-15 text-black"
                                }, null, 8, _hoisted_81)), [
                                  [_vModelText, conditionnement.prixMax]
                                ])
                              : (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    "onUpdate:modelValue": ($event: any) => ((conditionnement.prixMax) = $event),
                                    class: _normalizeClass(_ctx.isPrixMaxInvalid(conditionnement)
                            ? 'form-control shadow-none fs-md-15 text-black is-invalid'
                            : 'form-control shadow-none fs-md-15 text-black '),
                                    placeholder: "Entrer le prix maximal",
                                    "aria-label": "Sizing example input",
                                    "aria-describedby": "inputGroup-sizing-sm"
                                  }, null, 10, _hoisted_83), [
                                    [_vModelText, conditionnement.prixMax]
                                  ])
                                ])),
                            (_ctx.isPrixMaxInvalid(conditionnement))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_84, " Le prix Max doit être supérieur ou égal au prix de vente "))
                              : _createCommentVNode("", true),
                            (_ctx.valideteRowProduit(conditionnement.prixMax))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_85, " Le prix maximal est obligatoire. "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (index > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                              _createElementVNode("button", {
                                class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                                type: "button",
                                onClick: ($event: any) => (_ctx.removeRowConditionnement(index))
                              }, _cache[25] || (_cache[25] = [
                                _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                              ]), 8, _hoisted_87)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("button", {
                  class: _normalizeClass(["btn btn-success me-3", (!_ctx.isDisable || !_ctx.isDisableCha) ? { 'cursor-not-allowed': false } : { 'cursor-not-allowed': true }]),
                  type: "submit",
                  disabled: (_ctx.isDisable || _ctx.isDisableCha) ? true : false
                }, " Ajouter un produit ", 10, _hoisted_90),
                _createVNode(_component_router_link, {
                  to: "/produits/liste-produits",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[28] || (_cache[28] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "keep-values", "validation-schema"])
    ])
  ]))
}